var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.distinctPaths),function(p){return _c('item',{key:p,attrs:{"items":_vm.getPanelsByThematicPath(p),"name":p},on:{"selectedItem":function (e) { return _vm.$emit('selectedItem', e); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }